// src/componentForms/ContactFormComponent.jsx
import React from 'react';
import SingleColumnContactForm from './templates/contactForm/SingleColumnContactForm';
import TwoColumnContactForm from './templates/contactForm/TwoColumnContactForm';
import { useResponsiveStyles } from './useResponsiveStyles';

const ContactFormComponent = ({
  formFields,
  formName,
  buttonText,
  validationMessages,
  successMessage,
  template = 'SingleColumn',
  styles = {},
  onSubmit,
  componentId,
  subcomponentId,
}) => {
  const appliedStyles = useResponsiveStyles(styles);

  const commonProps = {
    formFields,
    formName,
    buttonText,
    validationMessages,
    successMessage,
    styles: appliedStyles,
    onSubmit,
    componentId,     // ✅ pass down
    subcomponentId,  // ✅ pass down
  };

  switch (template) {
    case 'TwoColumn':
      return <TwoColumnContactForm {...commonProps} />;
    case 'SingleColumn':
    default:
      return <SingleColumnContactForm {...commonProps} />;
  }
};

export default ContactFormComponent;
